export default "__VITE_ASSET__7ZOybQQd__"